import { render } from "./personalData.vue?vue&type=template&id=7e33fcc3&scoped=true"
import script from "./personalData.vue?vue&type=script&lang=js"
export * from "./personalData.vue?vue&type=script&lang=js"

import "./personalData.vue?vue&type=style&index=0&id=7e33fcc3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e33fcc3"]])

export default __exports__